module.exports = {
	// Use for large headings only.
	fontWeightLight: '300',
	// Most all body copy.
	fontWeightRegular: '400',
	// Used sparingly for emphasized text within regular body copy.
	fontWeightBold: '700',
	// Medium headings.
	fontSizeHeadingMedium: '1.125rem',
	fontSizeMedium: '1rem',
	// Small body text.
	fontSizeTextSmall: '.8125rem',
	fontSizeMediumA: '1.125rem',
	fontSizeXLarge: '1.5rem',
	fontSizeXLargeA: '1.57rem',
	// Extra large headings.
	fontSizeHeadingXLarge: '2rem',
	fontSizeXxLarge: '2rem',
	// Extra extra small text.
	fontSizeTextXxSmall: '.625rem',
	fontSizeLarge: '1.25rem',
	// Large headings.
	fontSizeHeadingLarge: '1.5rem',
	// Extra large body text.
	fontSizeTextXLarge: '1.25rem',
	fontSizeXSmall: '0.625rem',
	// Extra Extra small headings.
	fontSizeHeadingXxSmall: '.625rem',
	// Extra small headings.
	fontSizeHeadingXSmall: '.75rem',
	// Large body text.
	fontSizeTextLarge: '1.125rem',
	fontSizeSmall: '0.875rem',
	// Medium body text.
	fontSizeTextMedium: '1rem',
	// Extra small body text.
	fontSizeTextXSmall: '.75rem',
	// Small headings.
	fontSizeHeadingSmall: '.875rem',
	// Unitless line-heights for reusability
	lineHeightHeading: '1.25',
	// Unitless line-heights for reusability
	lineHeightText: '1.375',
	// Remove extra leading. Unitless line-heights for reusability
	lineHeightReset: '1',
	// Line heights for tabs
	lineHeightTab: '2.5rem',
	// Deprecated: use FONT_FAMILY_TEXT instead for regular body text and FONT_FAMILY_HEADING for headings.
	fontFamily: "'Salesforce Sans', Arial, sans-serif",
	fontFamilyText: "'Salesforce Sans', Arial, sans-serif",
	fontFamilyHeading: "'Salesforce Sans', Arial, sans-serif",
	fontFamilyMonospace: 'Consolas, Menlo, Monaco, Courier, monospace',
};
